/*
 * @Author: Json Chen
 * @Date: 2022-05-31 09:51:02
 * @LastEditTime: 2022-06-29 15:15:49
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/SubscriptionBuy/Detail/index.tsx
 */
import { getI18nFromGeneral } from '@/src/tools/tools';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import { get, isEqual } from 'lodash';
import qs from 'query-string';
import React from 'react';
import {
  //useDispatch,
  useSelector,
} from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router';
import { Form } from 'src/components/Antd';
import _RouteBlock from 'src/constrains/RouterBlock/RouterBlock';
import SalesChannelHOC, {
  SelectHOC,
} from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import { getCurrentSalesChannel } from 'src/constrains/SalesChannelHOC/slice';
import { SalesChannelModeAccessControlHOC } from 'src/constrains/SalesChannelModeAccessControl';
import {
  EnumMultiLanguageType,
  useQueryLanguageListContentEditor,
} from 'src/constrains/SalesChannelMultiLanguageSelect';
import { useI18n } from 'src/hooks/useRouterChange';
import { DiscountValueType } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/AtDiscountValue';
import {
  activeSubscriptionBuy,
  archiveSubscriptionBuy,
  draftSubscriptionBuy,
  getSelectedProduct,
  getSubscriptionBuy,
  postSubscriptionBuy,
} from 'src/request/salesChannel/discounts/subscriptionBuy';
import { NEW } from 'src/tools/constant';
import { onFinishFailed, timeoutScroll } from 'src/tools/helper';
import { msg } from 'src/tools/message';
import { i18nGet } from 'src/tools/tools';
import { ESubscriptionBuyType, EnumStatus } from 'src/types/common/discount';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import { modal } from 'src/utils/Modal';
import { Recurrence } from '../../Components/RecurrenceRange';
import { discountPermissions } from '../../Components/hooks/permissions';
import AdvancedFrequencyDiscount from './AdvancedFrequencyDiscount';
import Attributes from './Attribute';
import BasicInfo from './BasicInfo';
import Description from './Description';
import Frequency, { EFrequencyUnit } from './Frequency';
import Left from './Header/TopLeft';
import Right from './Header/TopRight';
import SubscriptionBuyProducts from './SubscriptionBuyProducts';
import SubscriptionDiscount from './SubscriptionDiscount';
import Summary from './Summary';
import { switchUuidHooks } from './hooks';
import { convertDataFromServer, convertDataFromState } from './tools';
const salesChannelMultiLanguageQueryParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  //  salesChannelMultiLanguageUpdate: true,
};
const salesChannelMultiLanguageParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  [EnumSalesChannelMultiLanguage.multiLanguageForceUpdate]: true,
};

const Item = Form.Item;
const nameDuplicate = 120618;
const formName = 'SubscriptionBuyForm';
const SubBuy = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const m: any = useLocation();
  const { defaultName } = qs.parse(m.search);

  const salesChannel = useSelector(getCurrentSalesChannel());
  const currency = get(salesChannel, 'currency');
  const currentLanguage = useQueryLanguageListContentEditor();
  const { isPrimary } = props;
  const { uuid: salesChannelUuid, discountUuid }: any = useParams();
  const { canViewDetail, canEdit, canDelete } =
    discountPermissions(salesChannelUuid);
  const history = useHistory();
  const [form] = Form.useForm();
  const defaultState = {
    salesChannelUuid: salesChannelUuid,
    status: EnumStatus.Draft,
    uuid: null,
    frequencies: [
      {
        recommended: true,
        frequency: 1,
        orderCount: 0,
        recurrence: Recurrence.EndAfter,
        frequencyUnit: EFrequencyUnit.Days,
        subscriptionType: ESubscriptionBuyType.PayUpfront,
        discount: {
          type: DiscountValueType.Percentage,
        },
      },
    ],
    salesChannelProducts: [],
    name: defaultName || '',
    payUpFrontPromo: '',
    recurringPaymentPromo: '',
  };
  const isNew = discountUuid === NEW;
  const [hasModified, setHasModified] = React.useState(false);
  const [data, setData] = React.useState({ ...defaultState });
  const [description, setDescription] = React.useState('');
  const [discountName, setDiscountName] = React.useState('');
  const [isEmpty, setIsEmpty] = React.useState(false);
  const [descHasError, setDescHasError] = React.useState(false);
  const { uuid: dUuid, status } = data;
  const isDraftArchive =
    status === EnumStatus.Draft || status === EnumStatus.Archived;
  const isActive =
    status === EnumStatus.Active ||
    status === EnumStatus.Scheduled ||
    status === EnumStatus.Expired;
  switchUuidHooks({ uuid: dUuid });
  const [selectedProducts, setSelectedProducts] = React.useState([]);
  const [loaded, setLoaded] = React.useState(false);
  const getData = () => {
    getSubscriptionBuy(discountUuid, salesChannelMultiLanguageQueryParams).then(
      (res) => {
        handleOnAssData(res);
        setLoaded(true);
        // return status;
      },
    );
  };
  React.useEffect(() => {
    if (isNew) {
      form.setFieldsValue(defaultState);
      setLoaded(true);
    }
  }, []);
  React.useEffect(() => {
    if (canViewDetail) {
      getSelectedProduct({
        salesChannelUuid,
        uuid: isNew ? null : discountUuid,
      }).then((products) => {
        const _products = products.map((i) => {
          const { productUuids, salesChannelProductUuid } = i;
          const _children = (productUuids || []).map((i) => {
            return { uuid: i };
          });
          const children = _children.length === 0 ? null : _children;
          return { uuid: salesChannelProductUuid, children };
        });
        setSelectedProducts(_products);
      });
    }
  }, [discountUuid]);

  React.useEffect(() => {
    if (canViewDetail) {
      if (!isNew) {
        setLoaded(false);
        getData();
      }
    }
  }, [currentLanguage]);

  const checkDesIsValid = () => {
    if (isEmpty) {
      return false;
    }
    return true;
  };
  const handleOnResponse = (response: any) => {
    const { data, status, errorCode, errMsg, code } = response;
    if (data && status == 200) {
      return {
        valid: true,
        data: data.payload,
      };
    }
    if (errorCode == nameDuplicate && code == 400) {
      timeoutScroll(`${formName}_name`);
      form.setFields([{ name: 'name', errors: [errMsg] }]);
      return {
        valid: false,
      };
    }
    modal.error({
      title: getI18n('general.requestError'),
      content:
        errMsg ||
        getI18n('general.tools_server.systemError,PleaseContactAdmin'),
      onCancel: () => {
        console.error(
          errMsg ||
            getI18n('general.tools_server.systemError,PleaseContactAdmin'),
        );
      },
      onCancelText: getI18n('general.confirm'),
    });

    return {
      valid: false,
    };
  };

  const handleOnAssData = (res) => {
    setData(res);

    const data = convertDataFromServer(res);

    const {
      name,
      salesChannelProducts,
      description,
      subscriptionDescription,
      applyToDifferentDiscount,
      frequencies,
      subscriptionBuyDiscount,
      attributes,
      payUpFrontPromo,
      recurringPaymentPromo,
    } = data;
    setDescription(description);
    setDiscountName(name);
    form.setFieldsValue({
      name,
      payUpFrontPromo,
      recurringPaymentPromo,
      salesChannelProducts,
      //  description,
      applyToDifferentDiscount,
      frequencies,
      subscriptionBuyDiscount,
      attributes,
      subscriptionDescription,
    });
  };
  const handleOnError = (error) => {
    const { errorFields } = error;

    if (errorFields[0] && isEqual(errorFields[0].name, ['frequencies'])) {
      timeoutScroll('salesChannelSubscriptionBuyFrequency');
    } else {
    }
    onFinishFailed(formName, error);
    return false;
  };

  const handleOnGetData = () => {
    const value = form.getFieldsValue();
    const _value = convertDataFromState(value, currency);
    const submitData = {
      ...data,
      ..._value,
      description,
      //  ...activeTime,
    };
    return submitData;
  };

  const handleOnSubmit = () => {
    if (isDraftArchive) {
      return handleOnSubmitDraft();
    }
    if (isActive) {
      return handleOnSubmitPublish();
    }
  };

  const handleOnSubmitDraft = () => {
    return form
      .validateFields(isPrimary ? ['name'] : []) //
      .then((res) => {
        const submitData = handleOnGetData();

        return postSubscriptionBuy(
          submitData,
          salesChannelMultiLanguageParams,
        ).then((res) => {
          const { valid, data } = handleOnResponse(res);
          if (valid) {
            setData(data);
            msg.success(getI18n('general.successfullyupdated'));
            setHasModified(false);
            return true;
          }
          return false;
        });
      })
      .catch(handleOnError);
  };

  const handleOnSubmitPublish = () => {
    const desIsValid = checkDesIsValid();
    if (desIsValid) {
      return form
        .validateFields()
        .then((res) => {
          //  const value = form.getFieldsValue();
          const submitData = handleOnGetData();
          return postSubscriptionBuy(
            submitData,
            salesChannelMultiLanguageParams,
          ).then((res) => {
            const { valid, data } = handleOnResponse(res);
            if (valid) {
              setData(data);
              msg.success(getI18n('general.successfullyupdated'));
              setHasModified(false);
              return true;
            }
            return false;
          });
        })
        .catch(handleOnError);
    } else {
      setDescHasError(true);
      timeoutScroll('salesChannelSubscriptionBuyDescription');
    }
  };

  const handleOnDuplicate = () => {
    const _duplicate = () => {
      const submitData = handleOnGetData();
      const { name } = submitData;
      submitData.name = `${name} Copy`;
      submitData.status = EnumStatus.Draft;
      submitData.uuid = null;
      submitData.salesChannelProducts = [];

      handleOnAssData(submitData);
      history.replace({
        pathname: `/salesChannel/discounts/subscriptionBuy/editor/${salesChannelUuid}/${NEW}`,
        state: {
          skipNotice: true,
        },
      });
      msg.destroy();
      msg.success(getI18n('general.duplicated'));
      timeoutScroll('tcContentTop');
    };
    //duplicate都是draft
    form.validateFields([]).then(() => {
      if (hasModified) {
        const promise = handleOnSubmit();
        if (promise) {
          promise.then((bol) => {
            //先提交
            if (bol) {
              _duplicate();
            }
          });
        }
      } else {
        _duplicate();
      }
    });
  };

  const handleOnToDraft = () => {
    form
      .validateFields(['name'])
      .then(() => {
        if (hasModified) {
          modal.info({
            title: getI18n('general.saveChanges'),
            content: getI18n(
              'salesChannelSubscriptionBuy.frequency.discardChange',
            ),
            //onCancel,
            onOkText: getI18n('general.saveChanges'),
            onOk: () => handleOnSubmit(),
            // onCancelText,
          });
        } else {
          const submitData = handleOnGetData();
          const { uuid } = submitData;
          draftSubscriptionBuy({ subscriptionBuyUuids: [uuid] }).then((res) => {
            msg.success(getI18n('general.successfullyupdated'));
            const status = EnumStatus.Draft;
            setData({ ...data, status });
            // handleOnAssData(res);
          });
        }
      })
      .catch(handleOnError);
  };

  const handleOnToArchive = () => {
    modal.info({
      title: getI18n('general.archiveDiscount'),
      content: getI18n('general.archiveTip'),
      //onCancel,
      onOkText: getI18n('general.archive'),
      onOk: () => {
        return form
          .validateFields(['name'])
          .then(() => {
            if (hasModified) {
              modal.info({
                title: getI18n('general.saveChanges'),
                content: getI18n('general.saveDiscount'),
                onCancel: () => {
                  return;
                },
                onOkText: getI18n('general.saveChanges'),
                onOk: () => handleOnSubmit(),
                // onCancelText,
              });
            } else {
              const submitData = handleOnGetData();
              const { uuid } = submitData;
              archiveSubscriptionBuy({ subscriptionBuyUuids: [uuid] }).then(
                (res) => {
                  msg.success(getI18n('general.successfullyupdated'));
                  const status = EnumStatus.Archived;
                  setData({ ...data, status });
                  // handleOnAssData(res);
                },
              );
            }
          })
          .catch(handleOnError);
      },
      // onCancelText,
    });
  };

  const handleOnToPublish = () => {
    const desIsValid = checkDesIsValid();
    if (desIsValid) {
      return form
        .validateFields()
        .then(() => {
          if (hasModified) {
            modal.info({
              title: getI18n('general.saveChanges'),
              content: getI18n('general.publishTip'),
              //onCancel,
              onOkText: getI18n('general.saveChanges'),
              onOk: () => handleOnSubmitPublish(),
              // onCancelText,
            });
          } else {
            const submitData = handleOnGetData();
            const { uuid } = submitData;
            activeSubscriptionBuy({ subscriptionBuyUuids: [uuid] }).then(
              (res) => {
                msg.success(getI18n('general.successfullyupdated'));
                const status = (res || [])[0] || EnumStatus.Active;
                setData({ ...data, status });
                // handleOnAssData(res);
              },
            );
          }
        })
        .catch((e) => {
          modal.info({
            title: getI18n('general.unabletoPublish'),
            content: getI18n('general.fixAllErr'),
            //onCancel,
            onOkText: getI18n('general.antd.Uploader.ok'),
            onOk: () => handleOnError(e),
            // onCancelText,
          });
        });
    } else {
      setDescHasError(true);
      timeoutScroll('salesChannelSubscriptionBuyDescription');
    }
  };

  const descriptionProps = {
    data: description,
    setData: setDescription,
    setIsEmpty: setIsEmpty,
    hasError: descHasError,
    setHasError: setDescHasError,
    setHasModified: setHasModified,
    disableEdit: !canEdit,
    currentLanguage,
  };

  return (
    <React.Fragment>
      <_RouteBlock
        onConfirm={(f) => f()}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.discard_content')}
      />
      {loaded && (
        <Form
          name='SubscriptionBuyForm'
          form={form}
          onValuesChange={(onValuesChange, ...rest) => {
            setHasModified(true);
          }}
          initialValues={
            {
              //frequencies: [{ name: 'zxc' }, { name: 'zxc1' }],
            }
          }>
          <Item
            shouldUpdate={(p, c) => {
              const pV = get(p, 'applyToDifferentDiscount');
              const cV = get(c, 'applyToDifferentDiscount');
              return pV !== cV;
            }}>
            {({ getFieldValue }) => {
              const isChecked = getFieldValue('applyToDifferentDiscount');
              let ele = [];
              if (!isPrimary) {
                ele = [
                  {
                    child: <Summary isPrimary={isPrimary} data={data} />,
                  },
                  { child: <BasicInfo disableEdit={!canEdit} /> },
                  {
                    child: <Description {...descriptionProps} />,
                  },
                  //  { child: <AdvancedFrequencyDiscount /> },
                  {
                    child: (
                      <Frequency
                        form={form}
                        isPrimary={isPrimary}
                        currency={currency}
                        disableEdit={!canEdit}
                      />
                    ),
                  },
                ];
              } else {
                if (isChecked) {
                  ele = [
                    {
                      child: <Summary isPrimary={isPrimary} data={data} />,
                    },
                    { child: <BasicInfo disableEdit={!canEdit} /> },
                    {
                      child: (
                        <SubscriptionBuyProducts
                          selectedProducts={selectedProducts}
                          disableEdit={!canEdit}
                        />
                      ),
                    },
                    {
                      child: <Description {...descriptionProps} />,
                    },
                    {
                      child: (
                        <AdvancedFrequencyDiscount disableEdit={!canEdit} />
                      ),
                    },
                    {
                      child: (
                        <Frequency
                          form={form}
                          isPrimary={isPrimary}
                          currency={currency}
                          disableEdit={!canEdit}
                        />
                      ),
                    },
                    { child: <Attributes disableEdit={!canEdit} /> },
                  ];
                } else {
                  ele = [
                    {
                      child: <Summary isPrimary={isPrimary} data={data} />,
                    },
                    { child: <BasicInfo disableEdit={!canEdit} /> },
                    {
                      child: (
                        <SubscriptionBuyProducts
                          selectedProducts={selectedProducts}
                          disableEdit={!canEdit}
                        />
                      ),
                    },
                    {
                      child: <Description {...descriptionProps} />,
                    },
                    {
                      child: (
                        <AdvancedFrequencyDiscount disableEdit={!canEdit} />
                      ),
                    },
                    {
                      child: (
                        <Frequency
                          form={form}
                          isPrimary={isPrimary}
                          disableEdit={!canEdit}
                        />
                      ),
                    },
                    {
                      child: (
                        <SubscriptionDiscount
                          currency={currency}
                          disableEdit={!canEdit}
                        />
                      ),
                    },
                    { child: <Attributes disableEdit={!canEdit} /> },
                  ];
                }
              }

              return (
                <Layout
                  topLeft={
                    <Left
                      name={discountName}
                      salesChannelName={get(salesChannel, 'name')}
                    />
                  }
                  topRight={
                    <Right
                      status={status}
                      isNew={isNew}
                      onDraft={handleOnToDraft}
                      onRestore={handleOnToDraft}
                      onPublish={handleOnToPublish}
                      onArchive={handleOnToArchive}
                      onDuplicate={handleOnDuplicate}
                      onSubmit={handleOnSubmit}
                      hasModified={hasModified}
                      isPrimary={isPrimary}
                      disableEdit={!canEdit}
                      disableDelete={!canDelete}
                    />
                  }
                  elements={ele}
                />
              );
            }}
          </Item>
        </Form>
      )}
    </React.Fragment>
  );
};
export default SalesChannelModeAccessControlHOC(
  SalesChannelHOC(SelectHOC(SubBuy), {
    type: EnumMultiLanguageType.SalesChannelDiscountsSubscriptionBuy,
  }),
);
